import { render } from "./request-treatment.vue?vue&type=template&id=0e5cf55b&scoped=true"
import script from "./request-treatment.vue?vue&type=script&lang=js"
export * from "./request-treatment.vue?vue&type=script&lang=js"

import "./request-treatment.vue?vue&type=style&index=0&id=0e5cf55b&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5cf55b"]])

export default __exports__